import { render, staticRenderFns } from "./PublicationStatementList.vue?vue&type=template&id=1bb1ee03&scoped=true&"
import script from "./PublicationStatementList.vue?vue&type=script&lang=js&"
export * from "./PublicationStatementList.vue?vue&type=script&lang=js&"
import style0 from "./PublicationStatementList.vue?vue&type=style&index=0&id=1bb1ee03&scoped=true&lang=scss&"
import style1 from "./PublicationStatementList.vue?vue&type=style&index=1&id=1bb1ee03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb1ee03",
  null
  
)

export default component.exports